import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import { edit, item } from '../../../lib/api/archive';

export function Edit({ archiveGuid, onClose, onUpdate }) {
  const [archive, setArchive] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const response = await item({ archive_guid: archiveGuid });
        const archiveItem = Array.isArray(response)
          ? response[0]
          : Array.isArray(response?.data)
            ? response.data[0]
            : response;

        setArchive(archiveItem || {});
      } catch (error) {
        console.error('Greska prilikom ucitavanja arhive:', error);
      }

      setLoading(false);
    })();
  }, [archiveGuid]);

  const handleInput = event => {
    const { name, value } = event.target;
    setArchive(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const nextErrors = {
      serial_number: !String(archive.serial_number || '').trim(),
      full_name: !archive.full_name?.trim(),
      birth_date: !archive.birth_date?.trim(),
      birth_place: !archive.birth_place?.trim(),
      registering_club: !archive.registering_club?.trim(),
      license_number: !archive.license_number?.trim()
    };

    setErrors(nextErrors);
    return !Object.values(nextErrors).some(Boolean);
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const payload = {
      serial_number: archive.serial_number || '',
      full_name: archive.full_name || '',
      gender: archive.gender || '',
      birth_date: archive.birth_date || '',
      birth_place: archive.birth_place || '',
      registering_club: archive.registering_club || '',
      previous_club: archive.previous_club || '',
      registration_date: archive.registration_date || '',
      license_number: archive.license_number || '',
      note: archive.note || ''
    };

    const response = await edit(payload, archiveGuid);
    const updatedArchive = Array.isArray(response)
      ? response[0]
      : response?.data?.[0] || response;

    onUpdate?.({
      ...archive,
      ...updatedArchive,
      archive_guid: archiveGuid
    });
    onClose?.();
  };

  return (
    <Card>
      <Card.Header>
        <Row className={classNames('g-2')}>
          <Col>
            <Flex>
              <h5 className="mb-0">Izmjena arhive</h5>
            </Flex>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit} noValidate>
          <Row className="mb-3">
            <Form.Group as={Col} md="4">
              <Form.Label>#</Form.Label>
              <Form.Control
                name="serial_number"
                value={archive.serial_number || ''}
                onChange={handleInput}
                isInvalid={errors.serial_number}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
            <Form.Group as={Col} md="8">
              <Form.Label>Ime i prezime</Form.Label>
              <Form.Control
                name="full_name"
                value={archive.full_name || ''}
                onChange={handleInput}
                isInvalid={errors.full_name}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="4">
              <Form.Label>Pol</Form.Label>
              <Form.Select
                name="gender"
                value={archive.gender || ''}
                onChange={handleInput}
                disabled={loading}
              >
                <option value="">Izaberi</option>
                <option value="M">Muški</option>
                <option value="F">Ženski</option>
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label>Datum rođenja</Form.Label>
              <Form.Control
                name="birth_date"
                value={archive.birth_date || ''}
                onChange={handleInput}
                isInvalid={errors.birth_date}
                placeholder="dd.MM.yyyy"
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label>Mjesto rođenja</Form.Label>
              <Form.Control
                name="birth_place"
                value={archive.birth_place || ''}
                onChange={handleInput}
                isInvalid={errors.birth_place}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6">
              <Form.Label>Klub registracije</Form.Label>
              <Form.Control
                name="registering_club"
                value={archive.registering_club || ''}
                onChange={handleInput}
                isInvalid={errors.registering_club}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
            <Form.Group as={Col} md="6">
              <Form.Label>Prethodni klub</Form.Label>
              <Form.Control
                name="previous_club"
                value={archive.previous_club || ''}
                onChange={handleInput}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6">
              <Form.Label>Datum registracije</Form.Label>
              <Form.Control
                name="registration_date"
                value={archive.registration_date || ''}
                onChange={handleInput}
                placeholder="dd.MM.yyyy"
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
            <Form.Group as={Col} md="6">
              <Form.Label>Broj licence</Form.Label>
              <Form.Control
                name="license_number"
                value={archive.license_number || ''}
                onChange={handleInput}
                isInvalid={errors.license_number}
                autoComplete="off"
                disabled={loading}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Napomena</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="note"
                value={archive.note || ''}
                onChange={handleInput}
                disabled={loading}
              />
            </Form.Group>
          </Row>

          <Button type="submit" disabled={loading}>
            Sačuvaj izmjene
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}
